<button class="scroll-top-button btn btn-primary position-fixed rounded-circle p-3 opacity-75 z-index-1">
  <div
    [inlineSVG]="'./assets/media/icons/duotune/arrows/arr081.svg'"
    class="svg-icon svg-icon-2 text-primary m-0"
  ></div>
</button>
